import { defineStore } from 'pinia'

// main is the name of the store. It is unique across your application
// and will appear in devtools
export const useUserStore = defineStore({
    id: 'user',
    // a function that returns a fresh state
    state: () => ({
        user: JSON.parse(localStorage.getItem('user')),
    }),
    // optional getters
    getters: {
        Fullname: (state) => state.user.Fullname,
        // getters receive the state as first parameter
        doubleCounter: (state) => state.counter * 2,
        // use getters in other getters
        doubleCounterPlusOne() {
            return this.doubleCounter + 1
        },
    },
    // optional actions
    actions: {
        reset() {
            // `this` is the store instance
            this.counter = 0
        },
        logout() {
            this.user = null;
            localStorage.removeItem('user');
            document.location = '/auth/login';
        }
    },
})
